import React from 'react'

export default function NoPage() {
  return (
    <>
    <div className='text-center'>
        <h1>Page Not Found</h1>
    </div>
    </>
  )
}
